export default __webpack_public_path__ + "static/media/selamat12.45235db0.svg";